import React, { useEffect, useRef, useState, useContext } from "react";
import { MessageContext } from "assets/js/syntax";
// import { client as axios } from "../../assets/js/axios";
import client from "assets/js/commonApi";
// import { ContractHtmlToText } from "assets/js/contractUtil";
import {
  ContractElementToText,
  GetContractValueObjectForText,
} from "assets/js/contractUtil";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import {
  Box,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  InputBase,
  Typography,
  TextField,
  Stack,
  InputAdornment,
} from "@mui/material";

import IconButton from "@mui/material/IconButton";
import IconTxtBtn from "components/btns/IconTxtBtn"; // 계약 담당자 검색 버튼(확장성있게 수정하기 애매)
import PaperComponent from "components/paper/PaperComponent"; // paper
import InputContent from "components/inputBox/InputContent"; // 내용
import DatePic from "components/picker/DatePic";
import ContractRadioBtn from "components/radio/ContractRadioBtn"; // 레디오 버튼
import {
  PAYMENT_TYPE_LABELS,
  PROCESSING_AT_END_LABELS,
  DATA_PROVIDED_LABELS,
  FILE_TYPE_LABELS,
} from "assets/hooks/constants/contractRadioButtonLabels"; // 레디오 버튼 라벨
import ContractAccordion from "components/accordion/ContractAccordion";
import SelectCompany from "components/selectBox/SelectCompany"; // 계약 담당자 - 선택 인풋창
import InputDisable from "components/inputBox/InputDisable"; // 계약 담당자 - 선택 후 값 자동 저장
import ContractNeedAddInput from "./ContractNeedAddInput";
import ModalContractHandlerSelect from "./ModalContractHandlerSelect"; // 담당자 선택

import { CircularIndeterminate } from "components/loaders/CircularIndeterminate";

// 담당자 선택
import { AppContext } from "App";
import { SelectForm } from "components/selectBox/SelectForm";

// 쿼리
import { useGroupSelectQuery } from "assets/hooks/useCategory/useSelectQuery";

// 기존타입
// S10_A
// S20_A
// stepS10A
// stepS20A

const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  // maxWidth: 400,
  margin: "8px auto",
  display: "flex",
  flex: 1,
  color: theme.palette.text.primary,
}));

const ModalDirectContractNew = ({
  onClose,
  contract_number,
  contract_sub_id,
  preamble,
  appendix,
  onRefresh,
  step_type,
}) => {
  // console.log(
  //   "##@@ step_type Received step_type in ModalDirectContractNew:",
  //   step_type,
  // );
  const { triggerRefresh } = useContext(MessageContext); // 전역 계약창 정보 업데이트 시 리프레쉬
  // 로그인 유저 정보
  const userDID = sessionStorage.getItem("did");
  // 240513 로그인 정보 업데이트
  const company = sessionStorage.getItem("company");
  const userName = sessionStorage.getItem("name");
  // 쿼리
  const selectedGroupQuery = useGroupSelectQuery();
  const { data: groups } = selectedGroupQuery;
  // useState
  const [isMessageLoading, setIsMessageLoading] = useState(false);
  const [contractNumber, setContractNumber] = useState("");
  console.log("## contractNumber", contractNumber);
  // const [changeUpdate, setChangeUpdate] = useState();
  const [recital, setRecital] = useState("");
  // const [preambleData, setPreambleData] = useState([company]); // 240416 추가
  // const [appendixData, setAppendixData] = useState([]); // 240416 추가
  const [preambleData, setPreambleData] = useState(); // 240416 추가
  const [appendixData, setAppendixData] = useState(); // 240416 추가
  const onPreambleChange = (event, newData) => {
    setPreambleData(newData);
  };

  const onAppendixChange = (event, newData) => {
    setAppendixData(newData);
  };
  const [from_dtm, setFrom_dtm] = useState(dayjs());
  const [to_dtm, setTo_dtm] = useState(dayjs());
  const [amount, setAmount] = useState(null);
  const [finalCnt, setfinalCnt] = useState(null);
  const [paymentValue, setPaymentValue] = useState("500");
  const [processingAtEndValue, setProcessingAtEndValue] = useState("600");
  const [dataProvidedValue, setDataProvidedValue] = useState("701");
  const [fileTypeValue, setFileTypeValue] = useState("800");
  const selectedPaymentTypeLabel = PAYMENT_TYPE_LABELS[paymentValue];
  const selectedProcessingAtEndLabel =
    PROCESSING_AT_END_LABELS[processingAtEndValue];
  const selectedDataProvidedLabel = DATA_PROVIDED_LABELS[dataProvidedValue];
  const selectedFileTypeLabel = FILE_TYPE_LABELS[fileTypeValue];

  const [buyerId, setBuyerId] = useState("");
  const [selectedGroup, setSelectedGroup] = useState(); // 그룹 선택창

  // 검색창 테스트 S
  const [selectedCompanyValue, setSelectedCompanyValue] = useState(); // 선택된 회사명
  // const [onSelectedCompanyValue, setOnSelectedCompanyValue] = useState();
  const [selectedCompanyInputValue, setSelectedCompanyInputValue] = useState();
  const [selectedCompanyName, setSelectedCompanyName] = useState();
  const [selectedManagerName, setSelectedManagerName] = useState();
  //
  const [selectedManagerValue, setSelectedManagerValue] = useState(); // 선택된 담당자

  const onSelectedCoNMgrChange = ({ coName, mgrName, userId }) => {
    setSelectedCompanyValue(coName);
    setSelectedManagerValue(mgrName);
    setBuyerId(userId);
  };

  // const onSelectCompanyInpChange = (event, value) =>
  //   setCompanyInputValue(value);
  // 검색창 테스트 E

  // *** 계약담당자선택 팝업 open NEW S
  const [handleBtn, setHandleBtn] = useState();
  const [isOpenModalHandlerSelect, setIsOpenModalHandlerSelect] =
    useState(false);
  // *** 계약담당자선택 팝업 open NEW E

  // const [companyData, setCompanyData] = useState([]); // 회사명 N 담당자 기본 데이터
  // 회사명 선택 콤보박스 { value: '회사코드', label: '회사명' }
  const [companyValue, setCompanyValue] = useState({});
  const [companyInputValue, setCompanyInputValue] = useState("");
  const [companyOptions, setCompanyOptions] = useState([]);
  // const onCompanyValueChange = (event, value) => setCompanyValue(value);
  // const onCompanyValueChange = (event, value) => {
  //   setCompanyValue(value);

  //   onPreambleChange(event, company);

  //   // onAppendixChange(event, value);
  // };
  const onCompanyValueChange = (event, newData) => {
    setCompanyValue(newData);
    // onPreambleChange(event, [company, newData.label]);
    onPreambleChange(event, `[${company}, ${newData.label}]`);
    // onAppendixChange(event, newData);
  };

  const onCompanyInputChange = (event, value) => setCompanyInputValue(value);
  // 담당자 선택 콤보박스 { value: 'did', label: '이름' }
  const [userValue, setUserValue] = useState({});
  const [userInputValue, setUserInputValue] = useState("");
  const [userOptions, setUserOptions] = useState([]);
  const onUserValueChange = (event, value) => setUserValue(value);
  const onUserInputChange = (event, value) => setUserInputValue(value);
  const onCompanyNUserGetOptionLabel = (option) =>
    option && option.label ? option.label : ""; // 회사 담당자 공통

  const preambleRef = useRef(); // 표준계약서
  const appendixRef = useRef(); // 부속계약서
  // const [preamble, setPreamble] = useState(); // 표준 계약서
  // const [appendix, setAppendix] = useState(); // 부속 계약서

  // 해당 셀렉터와 일치하는 첫 번째 자식 요소를 찾아 그 값을 반환
  const extractValue = (template, selector) =>
    template.firstElementChild.querySelector(selector)?.value;
  // HTML 문자열을 사용하여 새로운 HTML 템플릿을 생성
  const createTemplate = (html) => {
    const template = document.createElement("div");
    template.innerHTML = html.trim();
    return template;
  };
  // 데이터 확인용 - 최종구현 후 삭제
  const logValues = (prefix, values) => {
    Object.entries(values).forEach(([key, value]) => {
      console.log(`## ${prefix} ${key}`, value);
    });
  };

  // const commonSaveUpdate = () => {}

  // ** 저장 & 등록 S
  // commonSaveUpdate 저장 & 등록 공통
  const selectorsP = {
    "#sell_company": "sellCompany",
    "#buy_company": "buyCompany",
    "#data_type": "dataType",
    "#day": "day",
    "#d_range": "dRange",
    "#c_range": "cRange",
    "#s_day": "sDay",
    "#count": "count",
    "#year": "year",
    "#v_day": "vDay",
    "#r_day": "rDay",
    "#court": "court",
  };
  const selectorsX = {
    "#process": "process",
    "#process_data_type": "processDataType",
    "#process_month": "processMonth",
    "#process_d_rate": "processDRate",
    "#process_d_count": "processDCount",
    "#process_c_rate": "processCRate",
    "#process_c_count": "processCCount",
  };

  useEffect(() => {
    if (contractNumber) {
      console.log("계약 번호가 설정되었습니다:", contractNumber);
      // 여기에 계약 번호를 사용하여 실행할 추가 작업을 넣습니다.
      // 예: 다음 단계의 API 호출, UI 업데이트 등
    }
  }, [contractNumber]);

  // 저장(첫번째 임시 저장)
  const register = (step_type, btnSU) => {
    console.log("##@@ Updating - Loading starts"); // 로딩 시작 로그
    setIsMessageLoading(true); // 요청 전 로딩 시작
    const preamble = ContractElementToText(preambleRef.current); // 표준
    const appendix = ContractElementToText(appendixRef.current); // 부속

    const headers = { responseType: "stream" };

    // 계약서 타입(레디오버튼)
    const hist_types = {
      termination_type: processingAtEndValue,
      response_type: dataProvidedValue,
      data_type: fileTypeValue,
      payment_type: paymentValue,
    };

    // 계약서 히스토리 이력
    const contract_hist = {
      remark: null, // 수정 요청 사항 메시지 입력 > 등록 후에 입력되는 내용 매핑
      hist_to_dtm: to_dtm.format("YYYY-MM-DD"), // 동일
      hist_from_dtm: from_dtm.format("YYYY-MM-DD"), // 동일
      types: hist_types || null,
      hist_price: amount, // 동일하게
      hist_body: preambleData, // input값만 빼서 배열 형태
      hist_appendix: appendixData, // input값만 빼서 배열 형태
    };

    client
      .post(
        "/sell/insert",
        {
          // contract_sub_id: contract_sub_id,
          buyer_id: buyerId,
          seller_group_id: selectedGroup,
          contract_title: recital,
          step_type: step_type,
          to_dtm: to_dtm.format("YYYY-MM-DD"),
          from_dtm: from_dtm.format("YYYY-MM-DD"),
          contract_price: amount,

          payment_type: paymentValue,
          termination_type: processingAtEndValue,
          response_type: dataProvidedValue,
          data_type: fileTypeValue,

          contract_type: "001", // 고정타입 // 계약서 양식 다르니깐 박아두면 된다.
          // preamble: preamble,
          contract_body: preamble,
          contract_appendix: appendix,
          // contract_price: "계약금", // 입력이나/ 선택상관없다. // 좋은방법 생각
          final_cnt: finalCnt, // 계약정보내 있는거
          contract_hist: contract_hist || null,
        },
        { headers },
      )
      .then((response) => {
        const { status, data } = response;
        console.log("##@@ Updating - Loading ends"); // 로딩 종료 로그
        if (status === 200) {
          let shouldClose = true;
          setContractNumber(data.data); // 계약서 넘버
          setIsMessageLoading(false); // 데이터 처리 완료 후 로딩 종료
          switch (step_type) {
            case "100":
              alert("저장 하였습니다");
              shouldClose = false; // 저장버튼을 눌렀을 때는 창을 닫지 않음
              break;
            case "101":
              alert("등록 하였습니다");
              break;
            // case "100":
            //   if (btnSU === "S") {
            //     alert("저장 하였습니다");
            //     shouldClose = false; // 저장버튼을 눌렀을 때는 창을 닫지 않음
            //   }
            //   break;
            //   case "101":
            //      if (btnSU === "U") {
            //       alert("등록 하였습니다");
            //     }
          }
          if (shouldClose && onClose) onClose();
          onRefresh();
        }

        // const step100 = step_type === "100";
        // const step101 = step_type === "101";
        // const datas = response.data.data; // 계약서 넘버
        // if (response.data.msg === "판매 등록 및 저장 완료") {
        //   setContractNumber(response.data.data); // 계약서 넘버
        //   console.log("Received contract number:", response.data.data);
        //   if (step100) {
        //     alert("저장 하였습니다");
        //     triggerRefresh();
        //   } else if (step101) {
        //     alert("등록 하였습니다");
        //     triggerRefresh();
        //     if (onClose) onClose();
        //   }
        // }
        // console.log("## datas", datas); // 계약서 넘버
      })
      .catch((error) => {
        console.log("##@@ Updating - Error occurred, Loading ends"); // 에러 발생 및 로딩
        console.log("An error occurred:", error.response); // Handle error.
        setIsMessageLoading(false); // 오류 발생 시 로딩 종료
      });
  };

  // 등록
  const update = (step_type, btnSU) => {
    setIsMessageLoading(true); // 요청 전 로딩 시작
    const preamble = ContractElementToText(preambleRef.current); // 표준
    const appendix = ContractElementToText(appendixRef.current); // 부속

    console.log("## REF PREAMBLE", preamble);
    console.log("## REF APPENDIX", appendix);

    const headers = { responseType: "stream" };

    // 계약서 타입(레디오버튼)
    const hist_types = {
      termination_type: processingAtEndValue,
      response_type: dataProvidedValue,
      data_type: fileTypeValue,
      payment_type: paymentValue,
    };

    // 계약서 히스토리 이력
    const contract_hist = {
      remark: null, // 수정 요청 사항 메시지 입력 > 등록 후에 입력되는 내용 매핑
      hist_to_dtm: to_dtm.format("YYYY-MM-DD"), // 동일
      hist_from_dtm: from_dtm.format("YYYY-MM-DD"), // 동일
      types: hist_types || null,
      hist_price: amount, // 동일하게
      hist_body: preambleData, // input값만 빼서 배열 형태
      hist_appendix: appendixData, // input값만 빼서 배열 형태
    };

    client
      .post(
        "/sell/update", // (첫번째 저장 후)두번째 등록 = 업데이트
        {
          // contract_sub_id: "USTC-2404254-00001",
          step_type: step_type,
          contract_sub_id: contractNumber,
          buyer_id: buyerId,
          seller_group_id: selectedGroup,
          contract_title: recital, // 제목
          to_dtm: to_dtm.format("YYYY-MM-DD"), // 시작일
          from_dtm: from_dtm.format("YYYY-MM-DD"), // 종료일
          contract_price: amount, // 금액
          termination_type: processingAtEndValue,
          response_type: dataProvidedValue,
          data_type: fileTypeValue,
          payment_type: paymentValue,
          contract_type: "001", // 고정타입 // 계약서 양식 다르니깐 박아두면 된다.
          contract_body: preamble,
          contract_appendix: appendix,
          final_cnt: finalCnt, // 계약정보내 있는거
          contract_hist: contract_hist || null, // 구매자가 수정요청한 케이스 ?

          // contract_number: contractNumber,
          did_buyer: userValue.value,

          // recital: recital,
          // seller 제외
          // did_seller: userDID,
        },
        { headers },
      )
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          let shouldClose = true;
          setIsMessageLoading(false); // 데이터 처리 완료 후 로딩 종료
          console.log("##@@step_type", step_type);
          switch (step_type) {
            case "100":
              alert("저장 하였습니다");
              shouldClose = false; // 저장버튼을 눌렀을 때는 창을 닫지 않음
              break;
            case "101":
              alert("등록 하였습니다");
              break;
            // case "100":
            //   if (btnSU === "S") {
            //     alert("저장 하였습니다");
            //     shouldClose = false; // 저장버튼을 눌렀을 때는 창을 닫지 않음
            //   } else if (btnSU === "U") {
            //     alert("등록 하였습니다");
            //   }
            //   break;
          }
          if (shouldClose && onClose) onClose();
          onRefresh();
        }
        // const step100 = step_type === "100";
        // const step101 = step_type === "101";
        // if (
        //   response.data.msg === "판매 등록 및 저장 완료" ||
        //   response.data.msg === "수정 완료"
        // ) {
        //   if (step100) {
        //     alert("저장 하였습니다");
        //     triggerRefresh();
        //   } else if (step101) {
        //     alert("등록 하였습니다");
        //     triggerRefresh();
        //     if (onClose) onClose();
        //   }
        // }
      })
      .catch((error) => {
        console.log("An error occurred:", error.response); // Handle error.
        setIsMessageLoading(false); // 오류 발생 시 로딩 종료
      });
  };

  // **** 미 입력 S
  const [needAddInputOpen, setNeedAddInputOpen] = useState(false);
  const handleClickOpen = (params) => {
    setIsOpenModalHandlerSelect(true);
    setHandleBtn(params.target.value);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setNeedAddInputOpen(false);
    setIsOpenModalHandlerSelect(false);
  };

  // **** 유효성 확인 S
  const [inputChange, setInputChange] = useState({});
  const [message, setMessage] = useState();
  const onVaildate = (data) => {
    setInputChange(data);
  };

  const {
    label00,
    label01,
    label02,
    label03,
    label04,
    label05,
    label06,
    label07,
    label08,
    label09,
    label10,
    label11,
    label12,
    label13,
    label14,
    label15,
    label16,
    label17,
    label18,
    label19,
    label20,
    label21,
  } = useContext(MessageContext).messageList;
  const validationRules = [
    { field: "recital", label: label00 },
    // 240514 추가 S
    { field: "amount", label: label01 },
    { field: "finalCnt", label: label02 },
    { field: "selectedGroup", label: label03 },
    { field: "buyerId", label: label04 },
    // 240514 추가 E
    { field: "dataType", label: label05 },
    { field: "day", label: label06 },
    { field: "dRange", label: label07 },
    { field: "cRange", label: label08 },
    { field: "sDay", label: label09 },
    { field: "count", label: label10 },
    { field: "year", label: label11 },
    { field: "vDay", label: label12 },
    { field: "rDay", label: label13 },
    { field: "court", label: label14 },
    { field: "process", label: label15 },
    { field: "processDataType", label: label16 },
    { field: "processMonth", label: label17 },
    { field: "processDRate", label: label18 },
    { field: "processDCount", label: label19 },
    { field: "processCRate", label: label20 },
    { field: "processCCount", label: label21 },
  ];

  // 유효성 에 대한 팝업 표시
  const Validation = () => {
    // // 내용
    // if (recital.length === 0) {
    //   console.log("## [유효성 에러] 내용 입력", label00);
    //   setMessage(label00);
    //   return false;
    // }
    // 초기 필드 검사
    const initialFields = [
      { value: recital, label: label00 }, // 제목 = 기존내용
      { value: amount, label: label01 }, // 합계 금액
      { value: finalCnt, label: label02 }, // 데이터 총 제공 횟수
      { value: selectedGroup, label: label03 }, // 그룹 ID
      // { value: selectedGroup && selectedGroup !== "", label: label03 }, // 그룹 ID
      { value: buyerId, label: label04 }, // 계약 담당자 선택
    ];

    // 초기 필드 검사 수행
    for (const { value, label } of initialFields) {
      if (!value) {
        console.log(`## [유효성 에러]`, label);
        setMessage(label);
        return false; // 실패 시 검사 중단
      }
    }

    // 선택 & 표준계약서(부속)
    for (const rule of validationRules.slice(5)) {
      // 처음 5 개 항목을 제외한 나머지 검사
      const fieldValue = inputChange[rule.field]; // 동적으로 필드에 대한 값을 가져오기
      console.log(`## fieldValue ${rule.field}`, fieldValue);
      // 현재 룰의 필드에 해당하는 입력 데이터가 없거나 길이가 0이면 아래의 코드를 실행
      if (!fieldValue) {
        console.log(`## 유효성 에러 ${rule.field}`, rule.label);
        setMessage(rule.label); // 유효성 에러 메시지
        return false; // 유효성 검사에서 실패시 false를 반환하고 함수를 종료
      }
    }
    return true; // 모든 검사를 통과하면 true 반환
  };
  // **** 유효성 확인 E

  // 확인(구매자) & 저장(판매자) 그룹 아이디 유효성 체크
  // 구매자 확인 단계는 없으나, 코드가 중첩되는 부분이 있어 하나의 코드로 사용
  // const ValidationAdd = () => {
  //   // selectedGroup의 value 속성을 검사하여 유효한지 확인
  //   if (!selectedGroup || !selectedGroup.value) {
  //     console.log("## 유효성 에러: 그룹 ID 선택 필요");
  //     setMessage("그룹 ID를 선택해주세요.");
  //     return false;
  //   } else if (!) {
  //     setMessage("계약 담당자 선택을 해주세요.");
  //     return false;
  //   }
  //   return true; // 유효성 검사 통과
  // };

  const ValidationAdd = () => {
    // selectedGroup의 value 속성을 검사하여 유효한지 확인
    if (!buyerId) {
      console.log("## 유효성 에러: 계약 담당자 선택 필요");
      setMessage("계약 담당자를 선택해주세요.");
      return false;
    }
    return true; // 유효성 검사 통과
  };

  // 저장 & 등록 버튼 코드 병합
  const SaveUpdateButton = () => {
    console.log("## recital, recital.length", recital, recital.length);
    console.log("## contractNumber", contractNumber);

    // 저장
    const handleSaveBtn = () => {
      const target = "100";
      const action = contractNumber ? "update" : "register";
      // action === "register" && register(target);
      // action === "update" && update(target);
      if (!ValidationAdd()) {
        setNeedAddInputOpen(true); // 미 입력시 예외처리
        return;
      } else if (action === "register") {
        // 계약 번호가 없을때
        setNeedAddInputOpen(false);
        register(target, "S"); // register 살향 step_type 100을 보내주고, 저장 알림
      } else if (action === "update") {
        // 계약 번호가 있을때
        setNeedAddInputOpen(false);
        update(target, "S"); // update 실행 step_type 100을 보내주고, 저장 알림
      }
    };

    const handleUpdateBtn = () => {
      const target = "101";
      const action = contractNumber ? "update" : "register";
      if (Validation() === false) {
        setNeedAddInputOpen(true);
        return;
      }

      if (action === "register") {
        // 계약 번호가 없는 경우, 처음 등록하는 경우
        setNeedAddInputOpen(false);
        register(target, "U"); // 'U'는 등록(register)을 의미
      } else if (action === "update") {
        // 계약 번호가 있는 경우, 이미 저장된 데이터를 등록하는 경우
        setNeedAddInputOpen(false);
        update(target, "U"); // 'U'는 등록(update)을 의미
      }

      // triggerRefresh();
    };
    return (
      <>
        <Button onClick={handleSaveBtn}>저장</Button>
        <Button onClick={handleUpdateBtn}>등록</Button>
      </>
    );
  };

  // 금액 & 데이터 총 제공 횟수
  // const handleCountChange = (event) => {
  //   const { name, value } = event.target;
  //   // "" || 0 || null
  //   const countValue = value === "" ? value : Math.max(Number(value), 0);
  //   console.log("입력된 값:", countValue); // 입력값 로깅

  //   if (name === "amount") {
  //     // setAmount(countValue);
  //     setAmount(countValue !== null ? countValue : 0);
  //   } else if (name === "finalCnt") {
  //     // setfinalCnt(countValue);
  //     setfinalCnt(countValue !== null ? countValue : 0);
  //   }
  //   // setAmount(countValue);
  //   // setfinalCnt(countValue);
  // };

  const handleCountChange = (event) => {
    const { name, value } = event.target;
    let countValue;

    if (value === "") {
      countValue = ""; // 입력이 완전히 지워졌을 때 빈 문자열로 설정
    } else {
      // 첫 번째 자리가 '0'이고, 길이가 1을 초과하는 경우 '0'을 제거
      if (value.startsWith("0") && value.length > 1) {
        countValue = value.replace(/^0+/, "");
      } else {
        countValue = value;
      }

      // 음수 입력 방지 및 숫자 변환
      countValue = Math.max(Number(countValue), 0);
    }

    console.log("입력된 값:", countValue); // 입력값 로깅

    // 각 필드에 맞게 상태 업데이트
    if (name === "amount") {
      if (countValue > 10000000) {
        alert("금액은 천만을 넘을 수 없습니다");
      } else {
        setAmount(countValue.toString()); // 문자열로 변환하여 상태 업데이트
      }
    } else if (name === "finalCnt") {
      if (countValue > 10) {
        alert("데이터 제공 횟수는 10을 넘을 수 없습니다.");
      } else {
        setfinalCnt(countValue.toString()); // 문자열로 변환하여 상태 업데이트
      }
    }
  };

  // 스타일
  const radioSX = {
    // "& .Mui-disabled": {
    //   color: "#000000DE !important",
    //   "-webkit-text-fill-color": "#000000DE !important",
    // },
    "& .MuiRadio-root": {
      p: 0,
    },
  };

  // ****** 240116 코드추가 S

  // 그룹 선택 창
  const GroupOptions = groups
    ? groups.map((group) => ({
        value: group.group_id, // group_id 사용
        label: group.group_name, // group_name 사용
      }))
    : [];

  // const GroupOptions = [
  //   { value: "", label: "그룹 선택" }, // 기본 옵션 추가
  //   ...(groups
  //     ? groups.map((group) => ({
  //         value: group.group_id, // group_id 사용
  //         label: group.group_name, // group_name 사용
  //       }))
  //     : []),
  // ];

  return (
    <>
      <Box sx={{ flexGrow: 1, overflow: "hidden", px: 3 }}>
        <Dialog
          open={true}
          onClose={onClose}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
        >
          {isMessageLoading && <CircularIndeterminate />}
          <DialogTitle
            component="h1" // 헤딩태그 지정
            variant="h6" // 변형 사이즈
            // sx={modalContractSx}
            style={{ cursor: "move" }}
            id="draggable-dialog-title"
          >
            일반&#40;직접&#41; 계약서
          </DialogTitle>
          {/* 타이틀 */}
          <DialogContent>
            {contractNumber && (
              <Grid
                item
                container
                wrap="nowrap"
                spacing={2}
                sx={{ alignItems: "center", marginBottom: "8px" }}
              >
                <Grid item>
                  <Typography component="h2" variant="subtitle2">
                    계약번호
                  </Typography>
                </Grid>
                <Grid item xs zeroMinWidth>
                  <Typography
                    id="contract_number"
                    component="body1"
                    variant="subtitle2"
                  >
                    {contractNumber}
                  </Typography>
                </Grid>
              </Grid>
            )}
            {/* 계약번호 */}
            <Grid
              sx={{ flexGrow: 1 }}
              item
              xs={12}
              sm
              container
              direction="column"
            >
              <Grid item xs container direction="column" spacing={2}>
                <Grid item xs>
                  <Typography component="h2" variant="subtitle2">
                    제목
                  </Typography>
                  <StyledPaper
                    variant="outlined"
                    // sx={{
                    //   my: 1,
                    //   mx: "auto",
                    //   display: "flex",
                    //   flex: 1,
                    // }}
                  >
                    {/* <InputBase
                      // type="Number"
                      sx={{ width: "100%" }}
                      type="string"
                      placeholder="내용 입력"
                      inputProps={{ "aria-label": "내용 입력" }}
                      value={recital}
                      onChange={(event) => {
                        setRecital(event.target.value);
                        console.log("## 내용 입력 Test", event.target.value);
                      }}
                    /> */}
                    <InputContent
                      type="string"
                      value={recital}
                      placeholder="제목 입력"
                      inputProps={{ "aria-label": "제목 입력" }}
                      onChange={(event) => {
                        setRecital(event.target.value);
                        console.log("## 제목 입력", event.target.value);
                      }}
                      // disabled={DisabledTrue}
                      // helperText={PreContent[0]}
                    />
                  </StyledPaper>
                </Grid>
              </Grid>
              {/* 내용 설명 */}
              <Grid item xs container direction="column" spacing={2}>
                <Grid item xs>
                  <Typography component="h2" variant="subtitle2">
                    선택
                  </Typography>
                  <StyledPaper
                    variant="outlined"
                    sx={{
                      my: 1,
                      mx: "auto",
                      display: "flex",
                      flex: 1,
                      paddingBottom: "0",
                    }}
                  >
                    <Box
                      sx={{
                        p: 2,
                      }}
                    >
                      <Grid item xs container direction="column" spacing={2}>
                        <Grid
                          container
                          wrap="nowrap"
                          spacing={2}
                          sx={{ mb: "8px", width: "calc(100% + 49px)" }}
                        >
                          <Grid item>
                            <Typography
                              component="dt"
                              variant="subtitle2"
                              sx={{ mt: 0.5 }}
                            >
                              계약기간
                            </Typography>
                          </Grid>
                          <Grid item xs zeroMinWidth>
                            <DatePic
                              component="dd"
                              // fromValue={from_dtm}
                              // toValue={to_dtm}
                              fromValue={from_dtm}
                              toValue={to_dtm}
                              fromInputFormat={"yyyy-MM-dd"}
                              fromMask={"____-__-__"}
                              toInputFormat={"yyyy-MM-dd"}
                              toMask={"____-__-__"}
                              fromFormat="YYYY/MM/DD"
                              toFormat="YYYY/MM/DD"
                              fromOnChange={(newValue) => setFrom_dtm(newValue)}
                              toOnChange={(newValue) => setTo_dtm(newValue)}
                              // sx={radioSX}
                            />
                          </Grid>
                        </Grid>
                        {/* 계약기간 */}
                        <Grid
                          container
                          wrap="nowrap"
                          spacing={2}
                          // rowSpacing={2}
                          sx={{ mt: 0.5 }}
                        >
                          <Grid item>
                            <Typography
                              component="dt"
                              variant="subtitle2"
                              // gutterBottom
                            >
                              금액
                            </Typography>
                          </Grid>
                          <Grid item xs zeroMinWidth>
                            {/* <Stack
                              gap={0.5}
                              sx={{ display: "flex", flexDirection: "row" }}
                            > */}

                            <TextField
                              name="amount"
                              label="금액"
                              type="number"
                              // sx={{ m: 1, width: "25ch" }}
                              size="small"
                              value={amount}
                              // onChange={(e) => setAmount(e.target.value)}
                              onChange={handleCountChange}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    원
                                  </InputAdornment>
                                ),
                              }}
                              // InputProps={{
                              //   startAdornment: <InputAdornment position="start">kg</InputAdornment>,
                              // }}
                              // InputLabelProps={{
                              //   endAdornment: (
                              //     <InputAdornment position="end">
                              //       kg
                              //     </InputAdornment>
                              //   ),
                              // }}
                            />
                            {/* <Typography
                                // variant="h6"
                                sx={{
                                  display: "flex",
                                  alignItems: "flex-end",
                                  fontSize: 18,
                                }}
                              >
                                원
                              </Typography>
                            </Stack> */}
                          </Grid>
                        </Grid>
                        {/* 계약 금액 */}
                        <Grid
                          container
                          wrap="nowrap"
                          spacing={2}
                          // rowSpacing={2}
                          sx={{ mt: 0.5 }}
                        >
                          <Grid item>
                            <Typography
                              component="dt"
                              variant="subtitle2"
                              // gutterBottom
                            >
                              데이터 총
                              <Typography
                                component="span"
                                // variant="h5"
                                sx={{ display: "flex", fontSize: "inherit" }}
                              >
                                제공 횟수
                              </Typography>
                            </Typography>
                          </Grid>
                          <Grid item xs zeroMinWidth>
                            {/* <Stack
                              gap={0.5}
                              sx={{ display: "flex", flexDirection: "row" }}
                            > */}
                            <TextField
                              name="finalCnt"
                              label="데이터 총 제공 횟수"
                              type="number"
                              // sx={{ m: 1, width: "25ch" }}
                              size="small"
                              value={finalCnt}
                              // onChange={(e) => setAmount(e.target.value)}
                              onChange={handleCountChange}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    회
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                        </Grid>
                        {/* 데이터 총 제공 횟수 */}
                        <Grid
                          container
                          wrap="nowrap"
                          spacing={2}
                          // rowSpacing={2}
                          sx={{ mt: 1 }}
                        >
                          <Grid item>
                            <Typography
                              component="dt"
                              variant="subtitle2"
                              gutterBottom
                            >
                              결제
                            </Typography>
                          </Grid>
                          <Grid item xs zeroMinWidth>
                            <ContractRadioBtn
                              typeValue={paymentValue}
                              onChange={(value) => setPaymentValue(value)}
                              contractTypeLabels={PAYMENT_TYPE_LABELS}
                              // sx={DisabledSX}
                              sx={radioSX}
                            />
                          </Grid>
                        </Grid>
                        {/* 결제 */}
                        <Grid
                          container
                          wrap="nowrap"
                          spacing={2}
                          sx={{
                            // mt: 0.1,
                            mt: 1,
                          }}
                        >
                          <Grid item>
                            <Typography
                              component="dt"
                              variant="subtitle2"
                              gutterBottom
                            >
                              종료시 처리
                            </Typography>
                          </Grid>
                          <Grid item xs zeroMinWidth>
                            <ContractRadioBtn
                              typeValue={processingAtEndValue}
                              onChange={(value) =>
                                setProcessingAtEndValue(value)
                              }
                              contractTypeLabels={PROCESSING_AT_END_LABELS}
                              sx={radioSX}
                            />
                          </Grid>
                        </Grid>
                        {/* 종료시 처리 */}
                        <Grid
                          container
                          wrap="nowrap"
                          spacing={2}
                          sx={{ mb: "1px", mt: 1 }}
                        >
                          <Grid item>
                            <Typography
                              component="dt"
                              variant="subtitle2"
                              gutterBottom
                            >
                              데이터 제공 방식
                            </Typography>
                          </Grid>
                          <Grid item xs zeroMinWidth>
                            {/* <Typography component="dd" variant="p" gutterBottom> */}
                            <ContractRadioBtn
                              typeValue={dataProvidedValue}
                              onChange={(value) => setDataProvidedValue(value)}
                              contractTypeLabels={DATA_PROVIDED_LABELS}
                              sx={radioSX}
                            />
                            {/* </Typography> */}
                          </Grid>
                        </Grid>
                        {/* 데이터 제공 방식 */}
                        <Grid
                          container
                          wrap="nowrap"
                          spacing={2}
                          sx={{ mt: 1 }}
                        >
                          <Grid item>
                            <Typography
                              component="dt"
                              variant="subtitle2"
                              gutterBottom
                            >
                              제공 형태
                            </Typography>
                          </Grid>
                          <Grid item xs zeroMinWidth>
                            <ContractRadioBtn
                              typeValue={fileTypeValue}
                              onChange={(value) => setFileTypeValue(value)}
                              contractTypeLabels={FILE_TYPE_LABELS}
                              sx={radioSX}
                            />
                          </Grid>
                        </Grid>
                        {/*  제공 형태 */}
                        <Grid
                          container
                          wrap="nowrap"
                          spacing={2}
                          // rowSpacing={2}
                          sx={{ mt: 0.5 }}
                        >
                          <Grid item>
                            <Typography component="dt" variant="subtitle2">
                              그룹 선택
                            </Typography>
                          </Grid>
                          <Grid item xs zeroMinWidth>
                            <SelectForm
                              value={selectedGroup}
                              onSelectChange={setSelectedGroup}
                              // options={sortOptions}
                              options={GroupOptions}
                              label="그룹 선택"
                              placeholder="그룹 선택"
                            />
                          </Grid>
                        </Grid>
                        {/* 그룹 ID */}
                        <Grid
                          container
                          wrap="nowrap"
                          spacing={2}
                          sx={{
                            mt: 1,
                            display: "flex",
                            width: "calc(100% + 49px)",
                          }}
                        >
                          <Grid item>
                            <Typography
                              component="dt"
                              variant="subtitle2"
                              gutterBottom
                            >
                              계약 담당자
                            </Typography>
                          </Grid>
                          <Grid
                            container
                            item
                            xs
                            // xs={12}
                            zeroMinWidth
                            // direction="column"
                            gap={2}
                            // spacing={3}
                            sx={{
                              // width: "100%",
                              display: "flex",
                              // flexGrow: "1",
                            }}
                          >
                            {/* <IconButton
                              size="large"
                              aria-label="search"
                              color="inherit"
                              variant="contained"
                            >
                              <Typography component="span" variant="subtitle2">
                                회사명 & 담당자 선택
                              </Typography>
                            </IconButton> */}
                            <Grid item container>
                              <IconTxtBtn
                                value={handleBtn}
                                onClick={handleClickOpen}
                              />
                            </Grid>
                            <Grid
                              item
                              container
                              zeroMinWidth
                              spacing={2}
                              sx={{ flexGrow: 1 }}
                            >
                              {/* 이거하고 관련된거 최종수정 후 삭제하기 */}
                              <Grid item xs={12} md={6}>
                                {/* <SelectCompany
                                  value={companyValue} // 값 (api 호출 데이터 - 첫번재 배열)
                                  onChange={onCompanyValueChange} // 값 변경시 호출 (setCompanyValue를 담아줌)
                                  inputValue={companyInputValue} // 사용자 입력값
                                  onInputChange={onCompanyInputChange} // 입력값이 변경 될 때 &  변화처리 & 예 사용자 입력하는 동안 필터링 옵션 업데이트
                                  options={companyOptions} // 전체 데이터 가져와서 담아주는
                                  getOptionLabel={onCompanyNUserGetOptionLabel} // option이고 option.label이면(있으면) option.label(true) 아니면 빈문자열""(false)
                                  label="회사명 선택"
                                /> */}
                                <InputDisable
                                  label="회사명"
                                  value={selectedCompanyValue}
                                  focused={
                                    selectedCompanyValue ||
                                    (onSelectedCoNMgrChange && true)
                                  }
                                  InputLabelProps={
                                    selectedCompanyValue ||
                                    (onSelectedCoNMgrChange && true)
                                  }
                                  disabled={
                                    !selectedCompanyValue ||
                                    (!onSelectedCoNMgrChange && true)
                                  }
                                  // onChange={onSelectedCoNMgrChange}
                                  // onSelectedCoNMgrChange={
                                  //   onSelectedCoNMgrChange
                                  // }
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                {/* <SelectCompany
                                  value={userValue}
                                  onChange={onUserValueChange}
                                  inputValue={userInputValue}
                                  onInputChange={onUserInputChange}
                                  options={userOptions}
                                  getOptionLabel={onCompanyNUserGetOptionLabel}
                                  label="담당자 선택"
                                /> */}
                                <InputDisable
                                  label="담당자명"
                                  value={selectedManagerValue}
                                  focused={
                                    selectedManagerValue ||
                                    (onSelectedCoNMgrChange && true)
                                  }
                                  InputLabelProps={
                                    selectedManagerValue ||
                                    (onSelectedCoNMgrChange && true)
                                  }
                                  disabled={
                                    !selectedManagerValue ||
                                    (!onSelectedCoNMgrChange && true)
                                  }
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/*  계약 담당자 */}
                      </Grid>
                      {/* </Box> IN */}
                    </Box>
                    {/* </Box> */}
                  </StyledPaper>
                  {/* 선택 paper */}
                </Grid>
                {/* 선택 인 */}
              </Grid>
              {/* 선택 */}
              <ContractAccordion
                onVaildate={onVaildate}
                preamble={preamble}
                appendix={appendix}
                preambleRef={preambleRef}
                appendixRef={appendixRef}
                // sellerCompany={company}

                sellerCompany={company}
                // buyerCompany={companyValue.label}
                buyerCompany={selectedCompanyValue}
                onPreambleChange={onPreambleChange}
                // 부속 변경 이벤트
                onAppendixChange={onAppendixChange}
                // company={companyData}
                // buyerLabel={companyValue.label === false ? "구매회사" : ""}
                // 240116 S
                // 전문 변경 이벤트
                //
                // onPreambleChange={(event, newData) => {
                //   if (newData || companyData || setCompanyData) {
                //     setPreambleData(newData);
                //     // newData();
                //   }

                //   // setCompanyData();
                // }}
                // // 부속 변경 이벤트
                // onAppendixChange={(event, newData) => {
                //   if (newData || companyData || setCompanyData) {
                //     setAppendixData(newData);
                //     // newData();
                //   }
                // }}
                //
                // onPreambleChange={(e, newData) => {
                //   setPreambleData(newData);
                //   if (companyValue) {
                //     e();
                //   }
                // }}
                // // 부속 변경 이벤트
                // onAppendixChange={(e, newData) => {
                //   setAppendixData(newData);
                //   if (companyValue) {
                //     e();
                //   }
                // }}
                /////
                //               onPreambleChange={(e, newData) => {
                //                 setPreambleData(newData);
                // setCompanyData() => {
                //   setPreambleData(newData)
                // }}

                //               // 부속 변경 이벤트
                //               onAppendixChange={(e, newData) => {
                //                 setAppendixData(newData);
                //               }}
                ///////

                // 240116 E
              />
            </Grid>
            <Box sx={{ pt: 2, pb: 2 }}>
              <Grid
                item
                container
                wrap="nowrap"
                spacing={2}
                sx={{ justifyContent: "right", marginBottom: "8px" }}
              >
                <Grid item sx={{ alignItems: "right" }}>
                  <Typography
                    sx={{ color: "#717171" }}
                    component="h2"
                    variant="subtitle2"
                  >
                    판매자
                  </Typography>
                </Grid>
                <Grid item zeroMinWidth>
                  <Typography
                    sx={{
                      color: "#717171",
                      fontWeight: "900",
                      textAlign: "right",
                    }}
                    component="h2"
                    variant="subtitle2"
                  >
                    {userName}
                  </Typography>
                </Grid>
              </Grid>
              {/* 판매자 */}
              <Grid
                item
                container
                wrap="nowrap"
                spacing={2}
                sx={{ justifyContent: "right", marginBottom: "8px" }}
              >
                <Grid item sx={{ alignItems: "right" }}>
                  <Typography
                    sx={{ color: "#717171" }}
                    component="h2"
                    variant="subtitle2"
                  >
                    구매자
                  </Typography>
                </Grid>
                <Grid item zeroMinWidth>
                  <Typography
                    sx={{
                      color: "#717171",
                      fontWeight: "900",
                    }}
                    component="h2"
                    variant="subtitle2"
                  >
                    {selectedManagerValue}
                    {/* {userValue.label} */}
                  </Typography>
                </Grid>
              </Grid>
              {/* 구매자 */}
            </Box>
            {/* </Grid> */}
            {/* 콘텐츠 in */}
          </DialogContent>
          {/* 콘텐츠 */}
          <DialogActions>
            {/* <Agreement /> */}
            <SaveUpdateButton
              did={userDID} // 저장버튼 필요
              contract_number={contractNumber}
              // changeUpdate={changeUpdate} // 등록버튼 필요
            />
            {/* 등록55
            </UpdateButton> */}
            <Button onClick={onClose}>닫기</Button>
          </DialogActions>
          {needAddInputOpen && (
            <ContractNeedAddInput
              open={needAddInputOpen}
              handleClose={handleClose}
              message={message}
              // recital={recital}
            />
          )}
        </Dialog>
      </Box>
      {isOpenModalHandlerSelect && (
        <ModalContractHandlerSelect
          isOpen={isOpenModalHandlerSelect}
          handleClose={handleClose}
          onFinalClickInfoChange={onSelectedCoNMgrChange}
          // onClose={handleClose}
        />
      )}
    </>
  );
};

export default ModalDirectContractNew;
